import { Outlet } from 'react-router';
import { ToastContainer } from 'react-toastify';

interface IProps {
    containerClassName: string;
    mainClassName?: string;
    supportPhone: string | null;
}

const LayoutMain = ({ containerClassName, mainClassName, supportPhone }: IProps) => {
    const isProduction = import.meta.env.PROD;

    return (
        <>
            <main className={mainClassName}>
                <div className={containerClassName}>
                    <div className="main-content">
                        {!isProduction && (
                            <div className="alert alert-warning alert-sm">
                                WARNING: You are currently on a test server. If you are not testing, please do not proceed.
                            </div>  
                        )}
                        <Outlet />
                    </div>
                    <footer className="row">
                        <div className="col-xs-12 text-right">
                            {supportPhone && (
                                <div
                                    className="footer-support-phone"
                                    style={{ borderTop: '1px solid #ddd' }}
                                >
                                    <strong>For Support Call: {supportPhone}</strong>
                                </div>
                            )}
                        </div>
                    </footer>
                </div>
            </main>

            <ToastContainer position='top-center' autoClose={2000} theme='colored' />
        </>
    );
};

export default LayoutMain;
